import styled, { css } from 'styled-components'

import { Image, ImageProps } from '../../../components/Image'
import { brkmax, themeColor, themeSpace } from '../../../components/theme'

export const ReportContainer = styled.div<{ isPreferred: boolean }>`
  width: 100%;
  border: ${({ isPreferred }) => (isPreferred ? '3px' : '1px')} solid
    ${({ isPreferred }) => themeColor(isPreferred ? 'primary' : 'borderPrimary')};
  border-radius: 4px;
  padding: 24px;

  .report-name {
    margin-inline-start: 12px;
  }

  .desc {
    color: ${themeColor('textPrimary')};
    font-weight: normal !important;
    font-size: 14px !important;
    p {
      margin: 0;
    }
  }
`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Img = ({ opened, ...rest }: ImageProps & { opened?: boolean }) => <Image {...rest} />

export const ArrowIcon = styled(Img)`
  transform: rotate(90deg);
  transition: all 200ms ease-in;

  ${({ opened }) =>
    opened &&
    css`
      transform: rotate(-90deg);
    `}
`

export const ReportActionsContainer = styled.div<{ borderTop?: boolean; borderBottom?: boolean }>`
  width: 100%;
  margin-top: 24px;

  ${({ borderTop }) =>
    borderTop &&
    css`
      padding-top: 24px;
      border-top: 1px solid ${themeColor('borderPrimary')};
    `};

  ${({ borderBottom }) =>
    borderBottom &&
    css`
      margin-bottom: 24px;
      padding-bottom: 24px;
      border-bottom: 1px solid ${themeColor('borderPrimary')};
    `};

  .content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
`

export const ReportActions = styled.div<{ hasSample: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: ${({ hasSample }) => (hasSample ? 'space-between' : 'flex-end')};

  ${brkmax(
    1,
    css`
      flex-wrap: wrap;
      flex-direction: column-reverse;

      a {
        margin-top: ${themeSpace(1)};
        flex: 1 1 auto;
      }

      .buttons {
        width: 100%;

        button:last-of-type {
          flex: 1 1 auto;
        }
      }
    `
  )}
`
